import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import BottomNav from "../components/BottomNav";
import { useAuth } from "../contexts/AuthContext";
import { db } from "../firebase";
import { doc, updateDoc } from "firebase/firestore";
import "../styles/profile.css";

const EditProfile = () => {
const { userProfile, currentUser } = useAuth();
const navigate = useNavigate();

const [firstName, setFirstName] = useState("");
const [lastName, setLastName] = useState("");
const [displayName, setDisplayName] = useState("");
const [loading, setLoading] = useState(false);

useEffect(() => {
if (userProfile) {
setFirstName(userProfile.firstName || "");
setLastName(userProfile.lastName || "");
setDisplayName(userProfile.displayName || "");
}
}, [userProfile]);

const handleSave = async () => {
try {
setLoading(true);


  const userRef = doc(db, "users", currentUser.uid);

  await updateDoc(userRef, {
    firstName,
    lastName,
    displayName,
  });

  alert("Profile updated successfully ✅");

  navigate("/profile");
} catch (error) {
  console.error("Error updating profile:", error);
  alert("Failed to update profile");
} finally {
  setLoading(false);
}


};

if (!userProfile) {
return <div>Loading...</div>;
}

return ( <div className="profile-container"> <Navbar />

```
  <div className="profile-card">

    <h2>Edit Profile</h2>

    <div className="edit-inputs">

      <label>First Name</label>
      <input
        type="text"
        value={firstName}
        onChange={(e) => setFirstName(e.target.value)}
      />

      <label>Last Name</label>
      <input
        type="text"
        value={lastName}
        onChange={(e) => setLastName(e.target.value)}
      />

      <label>Display Name</label>
      <input
        type="text"
        value={displayName}
        onChange={(e) => setDisplayName(e.target.value)}
      />

    </div>

    <div className="profile-buttons">

      <button
        className="edit-btn"
        onClick={handleSave}
        disabled={loading}
      >
        {loading ? "Saving..." : "Save Changes"}
      </button>

      <button
        className="logout-btn"
        onClick={() => navigate("/profile")}
      >
        Cancel
      </button>

    </div>

  </div>

  <BottomNav />
</div>

);
};

export default EditProfile;
